import React, { useLayoutEffect, useRef, useState, useEffect } from 'react';
import animateScrollTo from 'animated-scroll-to';
import { Paths } from '../../../../models/Models';
import {
  getNavbarHeight,
  getViewportDimensions,
  keepSpaceTogether,
} from '../../../../models/Utils';
import VenetianBlindsText from '../../../Common/VenetianBlindsText/VenetianBlindsText';

import './PillarSlider.scss';

import LearnMoreLink from '../../../Common/LearnMoreLink/LearnMoreLink';
import Arrow from '../../../Common/Arrow/Arrow';
import { useSelector } from 'react-redux';
import { ADAARIARoles } from '../../../../models/ADA';
import { useMediaQuery } from 'react-responsive';

const togetherString = 'V Team';
const bottomBuffer = 80;

const PillarSlider = ({ data }) => {
  const cmsData = useSelector(state => state.data.cms.buildingBrighterFutures);
  const exploreMore = data.Introduction.ExploreMore;
  const sliderElement = useRef(null);
  const gridContainer = useRef(null);
  const gridRow = useRef(null);
  const numberOfBlocks = 4;
  const introTriggerRatio = 1.0;
  const [sliderContentDimensions, setSliderContentDimensions] = useState({ width: 0, height: 0 });
  const [spaceAround, setSpaceAround] = useState(0);
  const isAutoSliding = useRef(false);
  const blockElements = useRef();
  const [shownInIntro, setShownInIntro] = useState(1);
  const [animateIntro, setAnimateIntro] = useState(0);
  const [isFixed, setIsFixed] = useState(false);
  const refShownInIntro = useRef(shownInIntro);
  const refAnimateIntro = useRef(animateIntro);
  const slidesWrapper = useRef(null);
  const firstSlide = useRef(null);
  const secondSlide = useRef(null);
  const desktopLogoWrapper = useRef(null);
  const menuOpened = useSelector(state => state.data.menuOpened);

  const isDesktopView = useMediaQuery({ query: '(min-width: 767px)' });

  const adjustBlocks = (sliderY, sliderH) => {
    const unitHeight = sliderH / numberOfBlocks;
    const introBuffer = unitHeight * introTriggerRatio;
    const windowHeight = getViewportDimensions().height;
    const verticalPadding = windowHeight - unitHeight - bottomBuffer;
    const sliderTop = sliderElement.current.style.top || '0px';
    const actualSliderY = sliderY - parseFloat(sliderTop);
    const sliderOffsetY = Math.max(0, Math.min(verticalPadding - actualSliderY, introBuffer));
    let positions = [];
    for (let i = 0; i < numberOfBlocks; i++) {
      positions.push(
        Math.min(
          Math.max(0, verticalPadding - (actualSliderY + sliderOffsetY) - unitHeight * i),
          (numberOfBlocks - 1 - i) * unitHeight
        )
      );
    }
    const firstBlindsRect = firstSlide.current.getElementsByClassName('bbf-ps-intro-title')[0].getBoundingClientRect();
    if (firstBlindsRect.y + firstBlindsRect.height <= windowHeight && !refAnimateIntro.current) {
      setAnimateIntro(1);
      refAnimateIntro.current = 1;
    }
    if (firstBlindsRect.y + firstBlindsRect.height > windowHeight) {
      setAnimateIntro(0);
      refAnimateIntro.current = 0;
    }
    
    sliderElement.current.style.top = `${sliderOffsetY}px`;

    for (let i = 0; i < numberOfBlocks; i++) {
      blockElements.current[i].style.top = `${positions[i]}px`;
      if (i === 0) {

        if(sliderOffsetY > 0){   
          
          if(!isFixed){
            setIsFixed(true);
            var rect = firstSlide.current.getBoundingClientRect();
  
            firstSlide.current.classList.add("fixed");
            secondSlide.current.classList.add("fixed");
  
            firstSlide.current.style.width=rect.width +"px";
            firstSlide.current.style.left=rect.x + "px";
            firstSlide.current.style.top=rect.y +"px";

            secondSlide.current.style.width=rect.width +"px";
            secondSlide.current.style.left=rect.x + "px";
            secondSlide.current.style.top=rect.y +"px";
          }

        }else {
          firstSlide.current.classList.remove("fixed");
          secondSlide.current.classList.remove("fixed");

          firstSlide.current.style.width="unset";
          firstSlide.current.style.left="unset";
          firstSlide.current.style.top="unset";

          secondSlide.current.style.width="unset";
          secondSlide.current.style.left="unset";
          secondSlide.current.style.top="unset";
        }

        if (sliderOffsetY > introBuffer / 2 && refShownInIntro.current === 1) {
          setShownInIntro(2);
          refShownInIntro.current = 2;    
        } else if (sliderOffsetY < introBuffer / 2 && refShownInIntro.current === 2) {
          setShownInIntro(1);
          refShownInIntro.current = 1;
        }
      }
    }
  };

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (isAutoSliding.current) return;

      const sliderRect = sliderElement.current.getBoundingClientRect();
      adjustBlocks(sliderRect.y, sliderRect.height);
    };

    const handleResize = () => {
      const viewport = getViewportDimensions();
      const spaceAround = getNavbarHeight() + 20;
      const gridContainerWidth = gridContainer.current.getBoundingClientRect().width;
      const gridRowWidth = gridRow.current.getBoundingClientRect().width;
      const unitHeight = viewport.height - spaceAround - bottomBuffer;
      setSliderContentDimensions({
        width: Math.max(
          gridContainerWidth + (viewport.width - gridContainerWidth) / 2,
          gridRowWidth
        ),
        height: numberOfBlocks * unitHeight,
      });
      setSpaceAround(spaceAround);
    };

    if (!blockElements.current) {
      blockElements.current = sliderElement.current.getElementsByClassName('bbf-ps-block');
    }

    handleResize();
    handleScroll();

    document.body.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      document.body.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useLayoutEffect(() => {
    const introContentHeight = Math.max(
      firstSlide.current.getBoundingClientRect().height,
      secondSlide.current.getBoundingClientRect().height
    );
    slidesWrapper.current.style.height = `${introContentHeight}px`;
    desktopLogoWrapper.current.style.height = `${introContentHeight}px`;
  });

  useEffect(() => {
    setTimeout(() => {
      setAnimateIntro(shownInIntro);
      refAnimateIntro.current = shownInIntro;
    }, 500);
  }, [shownInIntro]);

  const goToBlock = (index, introBlockSubset) => {
    const sliderRect = sliderElement.current.getBoundingClientRect();
    const unitHeight = sliderRect.height / numberOfBlocks;
    const speed = 500; // ms for 1000px
    const start = document.body.scrollTop;
    const sliderTop = sliderElement.current.style.top || '0px';
    const actualSliderY = sliderRect.y - parseFloat(sliderTop);
    const targetSliderPos =
      actualSliderY +
      (index === 0 && introBlockSubset === 1 ? 0 : 1) * unitHeight * introTriggerRatio;
    const end = start + targetSliderPos + index * unitHeight - spaceAround;
    if (index === 0 && introBlockSubset) {
      document.body.scrollTo(0, end);
    } else {
      const t0 = Date.now();
      const tFinal = t0 + (Math.abs(end - start) / 1000) * speed;
      const animate = () => {
        let t = Date.now();
        if (t >= tFinal) t = tFinal;
        let tNormalized = (t - t0) / (tFinal - t0);
        const distDiff = (end - start) * (--tNormalized * tNormalized * tNormalized + 1); // easeOutCubic
        adjustBlocks(sliderRect.y - distDiff, sliderRect.height);
        document.body.scrollTo(0, start + distDiff);
        if (t < tFinal) {
          requestAnimationFrame(animate);
        } else {
          isAutoSliding.current = false;
        }
      };
      isAutoSliding.current = true;
      requestAnimationFrame(animate);
    }
  };

  const scrollFromBlock = (index, dir) => {
    const block = blockElements.current[index];
    const windowHeight = getViewportDimensions().height;
    if (dir === 'up') {
      if (index === 0 && refShownInIntro.current === 2) {
        goToBlock(0, 1);
      } else {
        if (block.getBoundingClientRect().y < windowHeight / 3) {
          goToBlock(index - 1);
        } else {
          goToBlock(index);
        }
      }
    } else {
      if (index === 0 && refShownInIntro.current === 1) {
        goToBlock(0, 2);
      } else {
        goToBlock(index + 1);
      }
    }
  };

  const getIntroBlock = () => {
    return (
      <div
        className="bbf-ps-block intro-block lightBg"
        style={{
          zIndex: 0,
        }}
      >
        <div className="cpvi-grid-container bbf-ps-block-fill-height">
          <div className="cpvi-grid-row bbf-ps-block-fill-height">
            <div className="bbf-ps-intro-title-holder cpvi-grid-col w6 bbf-ps-block-fill-height">
              <div className="bbf-ps-intro-left-content">
                <div className="bbf-ps-intro-logo-wrapper mobile"></div>
                <div className="bbf-ps-intro-slides-wrapper" ref={slidesWrapper}>
                  <div className={`bbf-ps-intro-slide slide-1`} ref={firstSlide}>
                    <div
                      className={`bbf-ps-intro-title ${
                        shownInIntro === 1 ? 'intro-show' : 'intro-hide'
                      }`}
                    >
                      <VenetianBlindsText show={animateIntro === 1} />
                      <h3 className="target-text" role={ADAARIARoles.Heading} >
                        {keepSpaceTogether(exploreMore.FirstIntroSlide.Header, togetherString)}
                      </h3>
                    </div>
                    <div
                      className={`bbf-ps-intro-subtitle desktop ${
                        shownInIntro === 1 ? 'intro-show' : 'intro-hide'
                      }`}
                    >
                      <h3 className="target-text" role={ADAARIARoles.Heading}>
                        {keepSpaceTogether(exploreMore.FirstIntroSlide.Body, togetherString)}
                      </h3>
                    </div>
                    <div
                      className={`bbf-ps-intro-subtitle mobile cont-75 ${
                        shownInIntro === 1 ? 'intro-show' : 'intro-hide'
                      }`}
                    >
                      <h3 className="target-text" role={ADAARIARoles.Heading}>
                        {keepSpaceTogether(exploreMore.FirstIntroSlide.Body, togetherString)}
                      </h3>
                    </div>
                    <LearnMoreLink
                      text={exploreMore.FirstIntroSlide.LinkText}
                      altText={exploreMore.FirstIntroSlide.LinkAltText}
                      className={`bbf-ps-pb-link ${
                        shownInIntro === 1 ? 'intro-show' : 'intro-hide'
                      }`}
                      to={exploreMore.FirstIntroSlide.Link}
                      external={true}
                      style={{
                        color: 'black',
                        borderColor: 'black',
                      }}
                    />
                  </div>
                  <div className={`bbf-ps-intro-slide slide-2`} ref={secondSlide}>
                    <div
                      className={`bbf-ps-intro-title ${
                        shownInIntro === 2 ? 'intro-show' : 'intro-hide'
                      }`}
                    >
                      <VenetianBlindsText show={animateIntro === 2} />
                      <span className="target-text" role={ADAARIARoles.Heading} >
                        {keepSpaceTogether(exploreMore.SecondIntroSlide.Header, togetherString)}
                      </span>
                    </div>
                    <div
                      className={`bbf-ps-intro-subtitle desktop ${
                        shownInIntro === 2 ? 'intro-show' : 'intro-hide'
                      }`}
                    >
                      <span className="target-text">
                        {keepSpaceTogether(exploreMore.SecondIntroSlide.Body, togetherString)}
                      </span>
                    </div>
                    <div
                      className={`bbf-ps-intro-subtitle mobile cont-75 ${
                        shownInIntro === 2 ? 'intro-show' : 'intro-hide'
                      }`}
                    >
                      <span className="target-text" >
                        {keepSpaceTogether(exploreMore.SecondIntroSlide.Body, togetherString)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bbf-ps-intro-logo-holder cpvi-grid-col w6 bbf-ps-block-fill-height desktop">
              <div className="bbf-ps-intro-logo-wrapper desktop" ref={desktopLogoWrapper}></div>
            </div>
          </div>
        </div>
       {/* <div className="bbf-ps-block-arrow down">
          <Arrow
            direction="down"
            darkMode={false}
            width="10px"
            handleClick={() => scrollFromBlock(0, 'down')}
          />
                    </div>*/}
      </div>
    );
  };

  const getPillarBlocks = () => {
    let pillarBlocks = [];
    for (let i = 1; i < numberOfBlocks; i++) {
      const card = exploreMore.Cards[i - 1];
      pillarBlocks.push(
        
        <div
          key={`pillar-block-${i}`}
          className={`bbf-ps-block pillar-block bl-${i}`}
          style={{ zIndex: i }}
        >
          <div className="bbf-ps-block-arrow up">
            <Arrow
              direction="up"
              darkMode={true}
              width="10px"
              handleClick={() => scrollFromBlock(i, 'up')}
            />
          </div>
          <div
            className="bbf-ps-block-bgnd"
            style={{ backgroundImage: `url("${card.Background.Image}")` }}
          >
            <div
              className="bbf-ps-block-bgnd-overlay"
              style={{
                opacity: card.Background.Opacity || 0,
                backgroundColor: card.Background.Overlay || null,
              }}
            ></div>
          </div>
          <div className="cpvi-grid-container bbf-ps-block-fill-height">
            <div className="cpvi-grid-row bbf-ps-block-fill-height">
              <div className="bbf-ps-pb-content cpvi-grid-col w6 bbf-ps-block-fill-height">
                <div className="">
                  <h3 className="bbf-ps-pb-header-text" role={ADAARIARoles.Heading} >
                    {keepSpaceTogether(card.Header, togetherString)}
                  </h3>
                  <div className="bbf-ps-pb-body-text desktop">
                    {keepSpaceTogether(card.Body, togetherString)}
                  </div>
                  <div className="bbf-ps-pb-body-text mobile cont-75">
                    {keepSpaceTogether(card.Body, togetherString)}
                  </div>
                  <LearnMoreLink
                    text={card.LearnMoreText}
                    altText={card.LearnMoreAltText}
                    className="bbf-ps-pb-link"
                    to={`/${cmsData.Path.Text}/${card.Pillar.Menu.Path}`}
                  />
                </div>
              </div>
            </div>
          </div>
          
          {i < numberOfBlocks - 1 && (
            <div className="bbf-ps-block-arrow down">
              <Arrow
                direction="down"
                darkMode={true}
                width="10px"
                handleClick={() => scrollFromBlock(i, 'down')}
              />
            </div>
          )}
        </div>
      );
    }
    return pillarBlocks;
  };

  return (
    <div className="bbf-pillar-slider" style={{ marginBottom: `${bottomBuffer}px` }}>
      <div className="cpvi-grid-container" ref={gridContainer}>
        <div className="cpvi-grid-row" ref={gridRow}></div>
      </div>
      <div
        className="bbf-ps-content"
        ref={sliderElement}
        style={{
          zIndex: 2,
          width: sliderContentDimensions.width,
          height: sliderContentDimensions.height,
        }}
      >
        {getIntroBlock()}
        {getPillarBlocks()}
      </div>
      <div
        className="bbf-ps-post-content"
        style={{
          zIndex: 1,
          height: (sliderContentDimensions.height / numberOfBlocks) * introTriggerRatio,
        }}
      ></div>
    </div>
  );
};

export default PillarSlider;
